export function getAll(data) {
    return abp.ajax({
        url: '/api/services/app/Company/GetAll',
        method: 'get',
        params: data
    });
}

export function createCompany(data) {
    return abp.ajax({
        url: '/api/services/app/Company/CreateAsync',
        method: 'post',
        data: data
    });
}

export function deleteCompany(id) {
    return abp.ajax({
        url: '/api/services/app/Company/DeleteAsync',
        method: 'delete',
        params: { id: id }
    });
}
